import Rails from '@rails/ujs';
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';

export default class ExtranetMoeSlotRequest {
  constructor() {
    this.calendar = null;
    this.state = {
      actionId: null,
      requestUrl: null,
      slotsUrl: null,
      selectedSlotId: null
    };
    this.bindEvents();
    this.bindModalEvents();
  }

  bindEvents() {
    $(document).on('click', '.moe-request-slot-btn', (e) => this.onRequestClick($(e.currentTarget)));
    $('#moeRequestSlotConfirm').on('click', () => this.submitRequest());
  }

  bindModalEvents() {
    $('#moeRequestSlotModal').on('shown.bs.modal', () => {
      if (!this.calendar) {
        this.initCalendar();
      } else {
        this.calendar.updateSize();
        this.calendar.refetchEvents();
      }
    });

    $('#moeRequestSlotModal').on('hidden.bs.modal', () => {
      this.state.selectedSlotId = null;
      $('#moeRequestSlotConfirm').prop('disabled', true);
      $('#moeRequestSlotError').addClass('d-none');
    });
  }

  onRequestClick(btn) {
    this.state.actionId  = btn.data('action-id');
    this.state.requestUrl = btn.data('request-url');
    this.state.slotsUrl   = btn.data('slots-url');
    this.state.selectedSlotId = null;

    $('#moeRequestSlotError').addClass('d-none');
    $('#moeRequestSlotConfirm').prop('disabled', true);

    // Destroy old calendar so it reinitialises with fresh state on shown.bs.modal
    if (this.calendar) {
      this.calendar.destroy();
      this.calendar = null;
    }

    $('#moeRequestSlotModal').modal('show');
  }

  initCalendar() {
    const calendarEl = document.getElementById('moeRequestSlotCalendar');
    if (!calendarEl || !this.state.slotsUrl) return;

    this.calendar = new Calendar(calendarEl, {
      plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
      initialView: 'dayGridMonth',
      initialDate: new Date(),
      locale: 'fr',
      timeZone: 'Europe/Paris',
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay'
      },
      buttonText: {
        today: "Aujourd'hui",
        month: 'Mois',
        week: 'Semaine',
        day: 'Jour'
      },
      slotMinTime: '07:00:00',
      slotMaxTime: '20:00:00',
      allDaySlot: false,
      height: 600,
      expandRows: true,
      nowIndicator: true,
      events: (info, successCb, failureCb) => {
        const url = new URL(this.state.slotsUrl, window.location.href);
        url.searchParams.set('start', info.startStr);
        url.searchParams.set('end', info.endStr);
        fetch(url, { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
          .then(r => {
            if (!r.ok) throw new Error(`HTTP ${r.status}`);
            return r.json();
          })
          .then(data => successCb(data.map(e => this._prepareEvent(e))))
          .catch(err => {
            $('#moeRequestSlotError').text('Erreur lors du chargement des créneaux.').removeClass('d-none');
            failureCb(err);
          });
      },
      eventClick: (info) => {
        if (info.event.extendedProps.pastDay) return;
        this.state.selectedSlotId = info.event.extendedProps.slot_id;
        this.calendar.getEvents().forEach(e => {
          if (!e.extendedProps.pastDay) {
            e.setProp('classNames', ['fc-slot--available']);
          }
        });
        info.event.setProp('classNames', ['fc-slot--selected']);
        $('#moeRequestSlotConfirm').prop('disabled', false);
      },
      noEventsContent: 'Aucun créneau disponible cette semaine - naviguez pour en trouver.'
    });

    this.calendar.render();
  }

  submitRequest() {
    if (!this.state.selectedSlotId) return;
    $('#moeRequestSlotConfirm').prop('disabled', true);
    const data = new URLSearchParams({
      action_execution_id: this.state.actionId,
      moe_slot_id: this.state.selectedSlotId,
      authenticity_token: $('meta[name="csrf-token"]').attr('content')
    }).toString();
    Rails.ajax({
      url: this.state.requestUrl,
      type: 'POST',
      data,
      success: (resp) => {
        if (resp.success) {
          $('#moeRequestSlotModal').modal('hide');
          location.reload();
        } else {
          $('#moeRequestSlotError').text(resp.error).removeClass('d-none');
          $('#moeRequestSlotConfirm').prop('disabled', false);
        }
      },
      error: (xhr) => {
        const msg = xhr && xhr.responseJSON && xhr.responseJSON.error ? xhr.responseJSON.error : 'Erreur serveur';
        $('#moeRequestSlotError').text(msg).removeClass('d-none');
        $('#moeRequestSlotConfirm').prop('disabled', false);
      }
    });
  }

  _prepareEvent(event) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (new Date(event.start) < today) {
      return { ...event, classNames: ['fc-slot--past'], title: 'Date passée', extendedProps: { ...event.extendedProps, pastDay: true } };
    }
    return { ...event, classNames: ['fc-slot--available'] };
  }

  onDestroy() {
    $(document).off('click', '.moe-request-slot-btn');
    $('#moeRequestSlotConfirm').off('click');
    $('#moeRequestSlotModal').off('shown.bs.modal hidden.bs.modal');
    if (this.calendar) {
      this.calendar.destroy();
      this.calendar = null;
    }
  }
}
